var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { GlobalContext, SearchResultsContext } from "@/contexts";
import { getClient } from "@/graphql/ApolloClient";
import { useEnsureCountryInUrl } from "@/hooks/useEnsureCountryInUrl";
import { useSearchResults } from "@/hooks/useSearchResults";
import { ApolloProvider } from "@apollo/client";
import { Flex, useRecipe } from "@chakra-ui/react";
import { useContext, useMemo } from "react";
import { Footer } from "@/components/Footer";
import { SearchResultsView } from "@/components/SearchResults";
import { Top } from "@/components/Top/Top";
var JobBoardContent = function () {
    var _a, _b;
    var properties = useContext(GlobalContext).properties;
    var searchResults = useSearchResults();
    var datePostedOptions = searchResults.error || searchResults.loading
        ? undefined
        : ((_b = (_a = searchResults.searchData) === null || _a === void 0 ? void 0 : _a.filterOptions.datePosted) !== null && _b !== void 0 ? _b : []);
    return (_jsxs(SearchResultsContext.Provider, __assign({ value: searchResults }, { children: [_jsx(Top, { modules: properties.modules, datePostedOptions: datePostedOptions }), _jsx(SearchResultsView, __assign({}, searchResults)), properties.modules.footer && _jsx(Footer, {})] })));
};
export var JobBoard = function () {
    var recipe = useRecipe({ key: "JobBoard" });
    var style = recipe();
    var _a = useContext(GlobalContext), properties = _a.properties, applyFlowParameters = _a.applyFlowParameters;
    var graphQLUri = properties.graphQLUri;
    var client = useMemo(function () {
        return getClient(graphQLUri, properties.placementId, applyFlowParameters === null || applyFlowParameters === void 0 ? void 0 : applyFlowParameters.userTrackingFlow);
    }, [graphQLUri, properties.placementId, applyFlowParameters === null || applyFlowParameters === void 0 ? void 0 : applyFlowParameters.userTrackingFlow]);
    // Ensure country is always present in URL
    useEnsureCountryInUrl();
    return (_jsx(Flex, __assign({ css: style, id: "job-board-body" }, { children: _jsx(ApolloProvider, __assign({ client: client }, { children: _jsx(JobBoardContent, {}) })) })));
};
